var _rect, _polyline, _line, _polyline2, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.749,
    width: 22.5,
    height: 22.5,
    rx: 1.5,
    ry: 1.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "12 4.499 7.5 10.499 4.5 7.499"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.25,
    y1: 8.249,
    x2: 18.75,
    y2: 8.249
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "12 13.499 7.5 19.499 4.5 16.499"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.25,
    y1: 17.249,
    x2: 18.75,
    y2: 17.249
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.b1fc66482a12e13fde7a97c048123524.svg";
export { ForwardRef as ReactComponent };